// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Component } from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Component
import TableFooter, { TableFooterBaseFCProps } from './TableFooter'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface TableFooterCProps extends TableFooterBaseFCProps {}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
class TableFooterContainer extends Component<TableFooterCProps> {
    render() {
        return <TableFooter {...this.props} />
    }
}

export default TableFooterContainer
